import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import LoginPage from './components/LoginPage';
import Layout from './components/Layout';
import DashboardPage from './components/dashboard/DashboardPage';
import LicensesPage from './components/licenses/LicensesPage';
import LicenseDetailPage from './components/licenses/LicenseDetailPage';
import InstancesPage from './components/servers/InstancesPage';
import ConnectionAttemptsPage from './components/servers/ConnectionAttemptsPage';
import PackagesPage from './components/packages/PackagesPage';
import UsersPage from './components/users/UsersPage';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

// Gestion des utilisateurs : ADMIN uniquement (DO-208) — le back renvoie 403 de toute façon
function AdminRoute({ children }) {
  const { user } = useAuth();
  return user?.role === 'ADMIN' ? children : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="licenses" element={<LicensesPage />} />
            <Route path="licenses/:id" element={<LicenseDetailPage />} />
            <Route path="instances" element={<InstancesPage />} />
            <Route path="attempts" element={<ConnectionAttemptsPage />} />
            <Route path="packages" element={<PackagesPage />} />
            <Route path="users" element={<AdminRoute><UsersPage /></AdminRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
